import React, { useContext, useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    SimpleGrid,
    useDisclosure,
    useToast,
} from '@chakra-ui/react';
import axios from 'axios';
import AuthContext from '../../contexts/AuthContext';
import { useCompany } from '../../contexts/CompanyContext';

const AddDipendenteModal = ({retrieveDipendenti}) => {
    const [dipendente, setDipendente] = useState({
        name: '',
        surname: '',
        birthdate: '',
        hire_date: '',
        contract: '',
        visita_medica: '',
        mansione: '',
        stipendio: '',
    });
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {getToken} = useContext(AuthContext);
    const toast = useToast();
    const {selectedCompany} = useCompany();

    const handleSubmit = async (e) => {
        e.preventDefault();

        axios.post(`/api/${selectedCompany['company_id']}/dipendenti`, dipendente, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }).then(response => {
                if(response.status === 201){
                    retrieveDipendenti(); // Refresh the list after creation
                    toast({
                        title: "Successo",
                        description: "Dipendente creato con successo.",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                    });

                    onClose(); // Chiude il modal dopo la creazione

                    // Reset the form
                    setDipendente({
                        name: '',
                        surname: '',
                        birthdate: '',
                        hire_date: '',
                        contract: '',
                        visita_medica: '',
                        mansione: '',
                        stipendio: '',
                    });
                }else{
                    console.error("Errore nella creazione del dipendente: " + response.data);
                    toast({
                        title: "Errore",
                        description: "Si è verificato un errore durante la creazione del dipendente.",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            }).catch((error) => {
                console.error("Errore nella creazione del dipendente", error);
                toast({
                    title: "Errore",
                    description: "Si è verificato un errore durante la creazione del dipendente.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            });
    };

    return (
        <>
            <Button onClick={onOpen} colorScheme="teal" mb={4}>
                Aggiungi Dipendente
            </Button>

            <Modal isOpen={isOpen} onClose={onClose} size='full'>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={handleSubmit}>
                        <ModalHeader>Anagrafica dipendente</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            {dipendente && (
                                <>
                                    <SimpleGrid columns={3} spacing={5} mb={5}>
                                        <FormControl id="name" isRequired>
                                            <FormLabel>Nome</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.name}
                                                onChange={(e) => setDipendente({ ...dipendente, name: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="surname" isRequired>
                                            <FormLabel>Cognome</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.surname}
                                                onChange={(e) => setDipendente({ ...dipendente, surname: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="birthdate" isRequired>
                                            <FormLabel>Data di nascita</FormLabel>
                                            <Input
                                                type="date"
                                                placeholder="YYYY-MM-DD"
                                                value={dipendente.birthdate}
                                                onChange={(e) => setDipendente({ ...dipendente, birthdate: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="hire_date" isRequired>
                                            <FormLabel>Data di assunzione</FormLabel>
                                            <Input
                                                type="date"
                                                placeholder="YYYY-MM-DD"
                                                value={dipendente.hire_date}
                                                onChange={(e) => setDipendente({ ...dipendente, hire_date: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="contract" isRequired>
                                            <FormLabel>Contratto</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.contract}
                                                onChange={(e) => setDipendente({ ...dipendente, contract: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="visita_medica" isRequired>
                                            <FormLabel>Visita medica</FormLabel>
                                            <Input
                                                type="date"
                                                placeholder="YYYY-MM-DD"
                                                value={dipendente.visita_medica}
                                                onChange={(e) => setDipendente({ ...dipendente, visita_medica: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="mansione" isRequired>
                                            <FormLabel>Mansione</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.mansione}
                                                onChange={(e) => setDipendente({ ...dipendente, mansione: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="stipendio" isRequired>
                                            <FormLabel>Stipendio</FormLabel>
                                            <Input
                                                type="number"
                                                step="0.01"
                                                value={dipendente.stipendio}
                                                onChange={(e) => setDipendente({ ...dipendente, stipendio: e.target.value })}
                                            />
                                        </FormControl>
                                    </SimpleGrid>
                                </>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="teal" mr={3} type="submit">
                                Crea
                            </Button>
                            <Button variant="ghost" onClick={onClose}>
                                Annulla
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
        </>
    );
};

export default AddDipendenteModal;